<template>
  <div class="col-2 station-search-row-note">
    <i :class="['far', icon, 'fa-fw']"></i> <span class="highlight"><slot /></span>
  </div>
</template>

<style scoped>
.station-search-row-note {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.station-search-row-note > i {
  color: #A0A0A0;
}
.station-search-row-note > .highlight {
  color: #FFFFFF;
  text-overflow: '';
  overflow: hidden;
  white-space: nowrap;
}
</style>

<script>
export default {
  name: 'StationSearchRowNote',
  props: {
    icon: String
  }
}
</script>